import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AuthModule } from '../../auth.module';

@Component({
  selector: 'password-reset',
  standalone: true,
  imports: [AuthModule],
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PasswordResetComponent {}
